
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { TYPES, SuccessMessages, ErrorMessages, webUrlAccess } from "../../common/constants";
import * as client from "../../services/client";
import { PATHS } from "../../common/constants";
import ReactGA from "react-ga4";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startFormLoading, stopFormLoading } from "./loader";
import { AnalyticsKey, resolutionHeader, matchUrl } from "../../Tenants";
import { tenants } from "../../common/TenantsInformation";

import { fetchUserSuites } from "./userSuites";
import { ToastSuccess, ToastFail } from "../../helpers/validationHelper";

export const signIn = (credentials, history, validate) => (dispatch) => {
  let data;
  dispatch(startFormLoading());
  return client
    .signIn(credentials)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          localStorage.setItem("userId", responsejson.user.id);
          localStorage.setItem("checked", "checked");
          if(AnalyticsKey) {
            ReactGA.initialize(AnalyticsKey);
            ReactGA.set({
              // userId: responsejson.user.id,
              userId: responsejson.user?.firstname + ' ' + responsejson.user?.lastname,
            });
          }

          data = responsejson.user;
          if (validate) {
          } else {
          setPermissions(responsejson.user, history, data, dispatch)
          dispatch({
            type: TYPES.AUTH_SIGN_IN_DONE,
            payload: responsejson,
          })
        }
        })

        if (validate) {
          client.changePassword(validate).then((response) => {
            if (response.status === 200) {
              response.json().then(responseJson => {                
                ToastSuccess(responseJson);
              })
              history.push(PATHS.SETTINGS);
            } else if(response.status === 201) {
              response.json().then(responseJson => {
                ToastFail(responseJson);
              })
            } else {
              toast.error("🚫 Password update failed.", {
                autoClose: 10000,
                position: "top-center",
              });
            }
          }).catch(() => {
            ToastFail(ErrorMessages.error);
          })
        } else {
        }
      } else {
        if(validate) {
          dispatch(stopFormLoading());
          ToastFail(ErrorMessages.wrongPassword);
        } else {
          dispatch(stopFormLoading());
          toast.error("🚫 Login failed, invalid email or password", {
            autoClose: 12000,
            position: "top-center",
          });
          dispatch({
            type: TYPES.AUTH_SIGN_IN_ERROR,
            payload: {
              message: "Login failed, invalid email or password",
            },
          });
        }
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      toast.error("Fetch Failed !", {
        autoClose: false,
        position: "top-center",
      });
    });
};

export const signUp = (credentials, history) => (dispatch) => {
  return client.saveContact(credentials).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        toast.success(
          " ⓘ You have signed up successfully! Please check your email for validating your account.",
          { autoClose: 10000, position: "top-center" }
        );
        history.push(PATHS.AUTH_SIGN_IN);
      });
    } else {
      response.json().then((responsejson) => {
        // alert('Something Went Wrong Please try again !')
      });
    }
  });
};

export const activateUser = (data, obj) => (dispatch) => {
  return client.activateUser(obj).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        if(responsejson.statusCode === 200) {
          toast.success(
            ` ⓘ Activation link sent to user ${data.firstname} ${data.lastname}`,
            { autoClose: 10000, position: "top-center" }
          );
        } else {
          toast.error( '🚫 Activation link sent failed, please try again.',{autoClose:4000,position:'top-center'});
        }
      });
    } else {
      toast.error( '🚫 Something went wrong, please try again.',{autoClose:4000,position:'top-center'});
    }
  }).catch(() => {
    toast.error( '🚫 Something went wrong, please try again.',{autoClose:4000,position:'top-center'});
  })
};

export const resetUserPassword = (data) => (dispatch) => {
  return client.forgotPassword(data.email).then((response) => {
    if (response.ok || response.status === 200) {
      toast.success(
        ` ⓘ Password reset link has been sent to user ${data.firstname} ${data.lastname} !`,
        { autoClose: 10000, position: "top-center" }
      );
    } else {
      toast.error( '🚫 Something went wrong, please try again.',{autoClose:4000,position:'top-center'});
    }
  }).catch(() => {
    toast.error( '🚫 Something went wrong, please try again.',{autoClose:4000,position:'top-center'});
  })
};

export const forceChangePassword = (data, history) => (dispatch) => {
  return client
    .forceChangePassword(data.UserId, { newPassword: data.Password })
    .then((response) => {
      if (response.ok || response.status === 200) {
        toast.success(
          " ⓘ You have changed your password. Please sign In with your credentials.",
          { autoClose: 10000, position: "top-center" }
        );
        history.push(PATHS.AUTH_SIGN_IN);
      }
    });
};

export const userActivateStatus = (userId) => {
  return client.userActivateStatus(userId);
};


export const changePassword = (data, history) => (dispatch) => {
  return client.changePassword(data).then((response) => {
    if (response.ok || response.status === 200) {
      toast.success(
        " ⓘ You have changed your password. Please sign In with your credentials.",
        { autoClose: 10000, position: "top-center" }
      );
      history.push(PATHS.AUTH_SIGN_IN);
    } else {
      toast.error( '🚫 Something went wrong while updating password, please try again.',{autoClose:4000,position:'top-center'});
    }
  }).catch(() => {
    toast.error( '🚫 Something went wrong, please try again.',{autoClose:4000,position:'top-center'});
  })
};

export const forgotPassword = (mailId, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client.forgotPassword(mailId).then((response) => {
    dispatch(stopFormLoading());    
    if (response.ok || response.status === 200) {
      toast.success("ⓘ A password reset link has been sent to your email.", {
        autoClose: 10000,
        position: "top-center",
      });
      history.push(PATHS.AUTH_SIGN_IN);
    } else if(response.status === 401) {
      response.json().then(responseJson => {
        toast.error(responseJson, {autoClose:4000,position:'top-center'});
      })
    } else if(response.status === 404) {
      toast.error("User does not exist with given email address.", {autoClose:4000,position:'top-center'});
    } else {
      toast.error("🚫 Something went wrong, please try again.", {autoClose:4000,position:'top-center'});
    }
  }).catch(() => {
    dispatch(stopFormLoading());
    toast.error( "🚫 Something went wrong, please try again.",{autoClose:4000,position:'top-center'});
  })
};

export const resetPassword = (credentials) => (dispatch) => {
  return client.resetPassword(credentials).then(
    (response) =>
      dispatch({
        type: TYPES.AUTH_RESET_PASSWORD_DONE,
        payload: response.data,
      }),
    (error) =>
      dispatch({
        type: TYPES.AUTH_RESET_PASSWORD_DONE,
        payload: {
          errors: error.response.data.errors,
        },
      })
  );
};

export const deleteUserAccountById = (userId, history) => (dispatch) => {
  return client.deleteContactById(userId).then((response) => {
    if (response.status === 200 || response.ok) {
      toast.success("ⓘ Your account has been deleted.", {
        autoClose: 10000,
        position: "top-center",
      });
      history.push(PATHS.AUTH_SIGN_IN);
    } else {
      // alert('Something went wrong Please try again!')
    }
  });
};

export const validateSlugCode = (slugCode) => (dispatch) => {
  return client.validateSlugCode(slugCode);
};

/*
    Modified By: Sai Prasad
    Modified Date: 25/08/2022 10:05 AM
    Jira Ticket: JUN-3161
    Description: user activation and reset password API.
*/
export const validateUser = (params, history) => (dispatch) => {
  dispatch(startFormLoading());
  return client.validateUser(params).then(response => {
    dispatch(stopFormLoading());
    if (response.status === 200 || response.ok) {
      response.json().then(responsejson => {
        if (responsejson.statusCode === 200) {
          ToastSuccess(SuccessMessages.passwordSuccess);
          history.push(PATHS.AUTH_SIGN_IN);
        } else if (responsejson.statusCode === 404) {
          ToastFail(ErrorMessages.userNotFound);
        } else if (responsejson.statusCode === 300) {
          ToastFail(ErrorMessages.userAlreadyActivated);
        } else if (responsejson.statusCode === 401) {
          ToastFail(ErrorMessages.linkHasExpired);
        } else if (responsejson.statusCode === 201) {          
          ToastFail(responsejson.message);
        } else {
          ToastFail(ErrorMessages.passwordFail);
        }
      })
    } else {
      ToastFail(ErrorMessages.error);
    }
  }).catch(() => {
    dispatch(stopFormLoading());
    ToastFail(ErrorMessages.error);
  })
};

export const fetchAuthenticatedUserDone = (payload) => ({
  type: TYPES.FETCH_AUTHENTICATED_USER_DONE,
  payload,
});

export const fetchAuthenticatedUser = () => (dispatch, getState) => {
  const user = selectAuthenticatedUser(getState());
  if (!user) {
    let data = localStorage.getItem("user");
    dispatch(fetchAuthenticatedUserDone(JSON.parse(data)));
  }
};

export const updateUserProfile = (profileData) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateUserProfile(profileData)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          let authToken = localStorage.getItem("auth");
          toast.success("ⓘ User profile has been updated.", {
            autoClose: 10000,
            position: "top-center",
          });
          responsejson.auth = JSON.parse(authToken);
          dispatch({
            type: TYPES.AUTH_SIGN_IN_DONE,
            payload: responsejson,
          });
        });
      } else if (response.status === 403) {
        toast.error(" 🚫 You have provided invalid calendly API key !", {
          autoClose: 10000,
          position: "top-center",
        });
      } else if (response.status === 409) {
        toast.error(" 🚫 Calendly API key with this url already exists !", {
          autoClose: 10000,
          position: "top-center",
        });
      } else {
        // alert('User profile update failed.')
      }
    })
    .catch(
      (error) => {
        dispatch(stopFormLoading());
      }
      // alert( 'Something Went Wrong in updating profile Please try again ! ')
    );
};

const fetchContactsDone = (payload) => ({
  type: TYPES.FETCH_CONTACTS_DONE,
  payload,
});

const savePropertyManagerDetails = (payload) => ({
  type: TYPES.PROPERTY_MANAGER_DETAILS_DONE,
  payload: payload,
});

const savePropertyManagerCalendlyLinkDone = (payload) => ({
  type: TYPES.PROPERTY_MANAGER_CALENDLY_DONE,
  payload: payload,
});
const fetchContacts = (dispatch) => {
  return client.getContacts().then((response) => {
    if (response.ok || response.status === 200) {
      response
        .json()
        .then((responsejson) => dispatch(fetchContactsDone(responsejson)));
    }
  });
};

export const getNewAuthorizationToken = async (userId) => {
  const url = webUrlAccess;
  let tenantObj = tenants.filter((tn) => matchUrl(tn.urls, url))[0];
  let baseAPIUrl = tenantObj && tenantObj.apiUrl ? tenantObj.apiUrl : "";
  const apiUrl = baseAPIUrl + 'api/UserManagement/Token/'+ userId;
  var authToken = localStorage.getItem('auth');

  let data = {
    'method': 'GET',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json',
      'Authorization': 'Bearer ' + JSON.parse(authToken),
      'Tenant-Id' : resolutionHeader
    }
  }

  await fetch(apiUrl, data).then(response => {
    if(response && response.status === 200) {
      response.json().then(responseJson => {  
        localStorage.setItem("auth", JSON.stringify(responseJson.auth));
      })
    }
  }).catch(error => { 
   })

  // return client.getNewAuthorizationToken(userId).then((response) => {
  //   if (response.status === 200 || response.ok) {
  //     response.json().then((responsejson) => {
  //       localStorage.setItem("auth", JSON.stringify(responsejson.auth));
  //     });
  //   }
  // });
};

export const setReport = (report) => (dispatch) => {
  return client.setReport(report).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {});
    }
  });
};

export const fetchPropertyManagerDetails =
  (userId, fetchLink) => (dispatch) => {
    return client.fetchPropertyManagerDetails(userId).then((response) => {
      if (response.status === 200) {
        response.json().then((responseJson) => {
          if (fetchLink && fetchLink === true) {
            dispatch(fetchCalendlyLink(responseJson.email));
          }
          dispatch(savePropertyManagerDetails(responseJson));
        });
      } else {
        // this.setState({ propertyDetails: []})
      }
    });
  };

export const fetchPropertyDetailsByProperty =
  (propertyId, fetchLink) => (dispatch) => {
    return client
      .fetchPropertyDetailsByProperty(propertyId)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((responseJson) => {
            if (fetchLink && fetchLink === true) {
              dispatch(fetchCalendlyLink(responseJson.email));
            }
            dispatch(savePropertyManagerDetails(responseJson));
          });
        } else {
          // this.setState({ propertyDetails: []})
        }
      });
  };

export const clearPropertyManagerDetails = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_PROPERTY_MANAGER_DETAILS,
  });
};
export const fetchCalendlyLink = (email) => (dispatch) => {
  client.fetchCalendlyLink(email).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responseJson) => {
        if (responseJson.statusCode === 200) {
          if (responseJson.data) {
            dispatch(
              savePropertyManagerCalendlyLinkDone({
                calendlyLink: responseJson.data.calendarLink,
                calendlyAPIKey: responseJson.data.calendlyAPIKey,
              })
            );
          } else {
            dispatch(savePropertyManagerCalendlyLinkDone({ calendlyLink: "" }));
          }

          // responseJson.data.user.scheduling_url
        } else if (responseJson.statusCode === 400) {
          dispatch(savePropertyManagerCalendlyLinkDone({ calendlyLink: "" }));

          //  alert('No calendar activation for this Property Developer');
        }
      });
    }
  });
};

export const setPermissions = async (responseJson, history, data, dispatch) => {
  let settings = {};
  if (responseJson && responseJson.permissions.ownerId) {
    for (
      let i = 0;
      i < responseJson.permissions.components[0].childComponents.length;
      i++
    ) {
      let childData = responseJson.permissions.components[0].childComponents[i];

      let result = await setOperation(childData.operations);
      settings = { ...settings, [childData.name]: result };
      for (let j = 0; j < childData.childComponents.length; j++) {
        let childOperationData = childData.childComponents[j];

        let result1 = await setOperation(childOperationData.operations);
        settings = { ...settings, [childOperationData.name]: result1 };
      }
    }
  }
  const redirectURL = localStorage.getItem("redirectURL");
  const homeOwnerIsRedirectFromEmailTemplateURL=window.location.href;
  localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate')
  let url= new URL(homeOwnerIsRedirectFromEmailTemplateURL);
  let URLparams = new URLSearchParams(url.search);
  if(URLparams.has('isShowFeedBackReportPopup') && URLparams.has('ServiceRequestId')){
    let ServiceRequestId= URLparams.get('ServiceRequestId');
    localStorage.setItem('IsHomerNavigatFromFeedBackTemplate',JSON.stringify({IsHomerNavigatFromFeedBackTemplate:true,ServiceRequestId:ServiceRequestId}))
  }
  const sessionTimeOut =
    localStorage.getItem("sessionTimeOut") === "true" ? true : false;
  if (redirectURL && sessionTimeOut !== true) {
    setTimeout(() => {
      history.push(redirectURL);
      localStorage.removeItem("redirectURL");
      if (sessionTimeOut === true) {
        localStorage.setItem("sessionTimeOut", "false");
      }
    });
  } else {
    setTimeout(() => {
      if (
        data &&
        data.roles &&
        data.roles.length > 0 &&
        data.roles[0].role.name === "Home Owner"
      ) {
        dispatch(fetchUserSuites(data.id, "logincall", data.roles[0].role.name));
        if(localStorage.getItem("user").isDashboardAccess===false) {
                localStorage.setItem("propertyId", data.propertyId);
        }
        window.location.href = PATHS.DASHBOARD
      } else {
        // history.push(PATHS.SERVICE_REQUESTS_LIST);
        window.location.href = PATHS.SERVICE_REQUESTS_LIST
      }
      if (sessionTimeOut === true) {
        localStorage.setItem("sessionTimeOut", "false");
      }
    }, 1000);
  }
  localStorage.setItem("permissions", JSON.stringify(settings));
};

export const setOperation = async (operations) => {
  let list = [];
  if (operations && operations.length > 0) {
    operations.map((operation) => {
      list = [...list, operation.name];
    });
    return list;
  } else {
    return list;
  }
};